module.exports = __webpack_public_path__ + "static/media/rede-protecao-8.6385dffb.jpeg";